import { iaRa } from 'lib/helpers/utility';

import { amountToCents } from 'components/practice/BeyondBilling/Claims/CMS1500/lib/amountToCents';

export const patient_responsibility = {
  PI: [204],
  CO: [51]
};

export const denied_codes = {
  // CO: ['B7', '24', '22', '256'],
  OA: ['B11'],
  PI: ['252']
};

export const provider_responsibility = {
  CO: [29]
};

export const patient_responsibility_codes = { PR: ['1', '2', '3', '100'] };

export const isStrictPatientRouting = (entry) => entry?.pt_routing_version === 1;

export const sumStampedAdjustments = (entry) => {
  let ptAdj = 0;
  let insBalance = 0;
  let insAdj = 0;

  for (const { type = '', amount } of [...iaRa(entry?.ins_adj), ...iaRa(entry?.pt_adj)]) {
    if (type === 'pt_rep') ptAdj += amountToCents(amount);
    else if (type === 'ins_balance') insBalance += amountToCents(amount);
    else insAdj += amountToCents(amount);
  }

  return { ptAdj, insBalance, insAdj };
};
